/**
 * Print developer message in browser
 */
export function printDeveloperMessageToConsole() {
  console.log(
    "%cWebsite by Lars Winkler",
    "color: #fa6467; font-size: x-large"
  );
  console.log(
    "%clwinkler.de / hallo@lwinkler.de",
    "color: darkgrey; font-size: large"
  );
}
